import { z } from '@hono/zod-openapi'
import { trustedBrandsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertTrustedBrand = z.infer<typeof zInsertTrustedBrand>
export type SelectTrustedBrand = z.infer<typeof zSelectTrustedBrand>
export type UpdateTrustedBrand = z.infer<typeof zUpdateTrustedBrand>
export type QueryTrustedBrands = z.infer<typeof zQueryTrustedBrands>
export type ColumnsOfTrustedBrandsTable =
    keyof typeof trustedBrandsTable._.columns

export const zSelectTrustedBrand = createSelectSchema(trustedBrandsTable)
export const zInsertTrustedBrand = createInsertSchema(trustedBrandsTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateTrustedBrand = zInsertTrustedBrand.partial()
export const zQueryTrustedBrands = zInsertTrustedBrand
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
